import { PropsWithChildren } from "react";

export type TabProps = PropsWithChildren<{ label: string }>;

export default function Tab(props: TabProps) {
  return <></>;
}
